module.exports = __webpack_public_path__ + "img/4.8eb9dc49.png";